// extracted by mini-css-extract-plugin
export default {"duration":"duration__ZWRk0K"};